let showTheSouthChinaSeaIslands = true;

let ecChinaMap = ({dom, cityArr=[], echarts}) => {
    echarts.dispose(dom);
    let myChart = echarts.init(dom);
    console.log('cityArr', cityArr);
    // cityArr=[];

    let option = {
        // tooltip: {
        //     trigger: 'item',
        //     formatter: '{b}'
        // },
        tooltip: {
            show: true,
            trigger: 'item',
            formatter: function(params) {
                return '123';
            },
        },
        geo: {
            type: 'map',
            name: '中国',
            map: 'china',
            zoom: 1.1,
            label: {
                show: false,
            },
            itemStyle: {
                // color: 'red',
                borderColor: 'rgb(0,9,49)',
                areaColor: 'rgb(0,41,96)',
            },
            emphasis: {
                label: {
                    show: true,
                    color: '#FFFFFF',
                    fontSize: '0.14rem',
                    position: ['50%', '50%'],
                },
                itemStyle: {
                    borderColor: '#00082E',
                    areaColor: '#0DC2B6'
                }
            },
            data: [],
            regions: []
        },
    };

    let colorList = [
        {
            borderColor: '#00082E',
            areaColor: '#25C1B5',
        },
        {
            borderColor: '#00082E',
            areaColor: '#1ea5a2',
        },
        {
            borderColor: '#00082E',
            areaColor: '#188990',
        },
        {
            borderColor: '#00082E',
            areaColor: '#136c7d',
        },
        {
            borderColor: '#00082E',
            areaColor: '#076784',
        },
    ];

    cityArr.forEach((city, index) => {
        let i = index;
        (i > 4) && (i = 4);
        let colorMap = colorList[i];
        option.geo.regions.push({
            name: city.name,
            selected: city.selected,
            label: {
                show: true,
                color: '#7AE3FF',
                fontSize: '0.14rem',
            },
            itemStyle: {
                // color: 'red',
                // borderColor: 'rgb(30,83,141,.54)',
                // areaColor: 'rgb(58,103,163,.54)',
                // borderColor: colorMap.borderColor,
                // areaColor: colorMap.areaColor,
            },
            emphasis: {
                itemStyle: {
                    borderColor: colorMap.borderColor,
                    areaColor: colorMap.areaColor,
                }
            }
        });
    });
    try {

    } catch(e) {console.log(e);debugger}


    // 必须要明确设置成false才可以 南海诸岛要显示的
    (showTheSouthChinaSeaIslands === false) && option.geo.regions.push({name: '南海诸岛', itemStyle: {normal: {opacity: 0, label: {show: false}}}})

    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option);
};

export default ecChinaMap;
